<template>
  <Teleport to="body">
    <div v-if="show" class="modal-backdrop" @click="handleOutsideClick">
      <div class="modal-container" @click.stop>
        <div class="modal-content">
          <slot />
        </div>
        <div class="modal-footer">
          <slot name="left-button" />
          <button class="close-button" @click="closeModal" role="button">
            {{ $t('common.actions.close') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
const props = defineProps<{
  show: boolean;
  closeOnOutsideClick?: boolean;
  onClose?: () => void;
}>();

const emits = defineEmits(['update:show']);

function closeModal() {
  if (props.onClose) {
    try {
      props.onClose();
    } catch (error) {
      console.error('Error in onClose handler:', error);
    }
  }
  emits('update:show', false);
}

function handleOutsideClick() {
  if (props.closeOnOutsideClick) closeModal();
}
</script>

<style scoped lang="scss">
.modal-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-container {
  display: flex;
  flex-direction: column;
  background-color: $color-neutral-0;
  max-width: 80vw;
  border-radius: $radius-4;
  border: 1px solid $color-neutral-200;
  padding: 1rem;
}

.modal-content {
  max-height: 80vh;
  overflow-y: auto;
}

.modal-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
}

.close-button {
  cursor: pointer;
  user-select: none;
  padding: $space-2 $space-3;
  color: $color-information-900;
  font-size: $body-m-font-size;
  line-height: $body-m-line-height;
  font-weight: $fw-medium;
  border: none;
  background-color: transparent;
  background: transparent;
}
</style>
